import PageMeta from "../components/PageMeta";
import PublisherCard from "../components/PublisherCard";
import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import EngagementActions from "../components/EngagementActions";
import PrintButton from "../components/PrintButton";
import { addReservation, calendarDate, reservationEstimate, stayNights } from "../Services/reservationService";
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { getAuth } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import { fr, enGB, arTN } from "date-fns/locale";

import {
  LuBath,
  LuBedDouble,
  LuCalendarDays,
  LuCamera,
  LuCheck,
  LuCircleParking,
  LuCookingPot,
  LuFlame,
  LuImage,
  LuMapPin,
  LuMessageSquare,
  LuSend,
  LuSnowflake,
  LuSofa,
  LuTrees,
  LuTv,
  LuUmbrella,
  LuUsers,
  LuWashingMachine,
  LuWifi,
  LuX,
} from "react-icons/lu";

import {
  getReservedDates,
  getVacationById,
} from "../Services/vacationsService";

import { photoUrl } from "../Variables";

import Spinner from "../components/Spinner";

import "react-datepicker/dist/react-datepicker.css";

const getDefaultMessage = () => uiI18n.t("ui.vacation_message");

const FALLBACK_IMAGE =
  "/images/property-placeholder.jpg";

const inputClassName = `
  h-12
  w-full
  rounded-2xl
  border
  border-slate-200
  bg-white
  px-4
  text-sm
  font-medium
  text-slate-900
  outline-none
  transition
  placeholder:text-slate-400
  hover:border-slate-300
  focus:border-green-500
  focus:ring-4
  focus:ring-green-500/10
`;

const amenitiesList = [
  {
    key: "wifi",
    labelKey: "amenities.wifi",
    get fallback() { return uiI18n.t("ui.wi_fi"); },
    icon: LuWifi,
  },
  {
    key: "workspace",
    labelKey: "amenities.workspace",
    get fallback() { return uiI18n.t("options.espacedetravail"); },
    icon: LuSofa,
  },
  {
    key: "parking",
    labelKey: "amenities.parking",
    get fallback() { return uiI18n.t("ui.parking"); },
    icon: LuCircleParking,
  },
  {
    key: "piscine",
    labelKey: "amenities.piscine",
    get fallback() { return uiI18n.t("options.picine"); },
    icon: LuUmbrella,
  },
  {
    key: "tv",
    labelKey: "amenities.tv",
    fallback: "Télévision",
    icon: LuTv,
  },
  {
    key: "camera",
    labelKey: "amenities.camera",
    fallback: "Caméra",
    icon: LuCamera,
  },
  {
    key: "barbecue",
    labelKey: "amenities.barbecue",
    get fallback() { return uiI18n.t("ui.barbecue"); },
    icon: LuFlame,
  },
  {
    key: "beachAccess",
    labelKey: "amenities.beachAccess",
    get fallback() { return uiI18n.t("ui.beach_access"); },
    icon: LuUmbrella,
  },
  {
    key: "ac",
    labelKey: "amenities.ac",
    get fallback() { return uiI18n.t("ui.air_conditioning"); },
    icon: LuSnowflake,
  },
  {
    key: "kitchen",
    labelKey: "amenities.kitchen",
    get fallback() { return uiI18n.t("options.cuisine"); },
    icon: LuCookingPot,
  },
  {
    key: "washer",
    labelKey: "amenities.washer",
    get fallback() { return uiI18n.t("options.lavelinge"); },
    icon: LuWashingMachine,
  },
  {
    key: "garden",
    labelKey: "amenities.garden",
    get fallback() { return uiI18n.t("options.jardin"); },
    icon: LuTrees,
  },
];

function searchedStay() {
  const query = new URLSearchParams(window.location.search);
  const parse = value => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
  };
  const start = parse(query.get("checkIn")), end = parse(query.get("checkOut"));
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return start && end && end > start && start >= today ? { start, end } : null;
}

const DetailsVacation = () => {
  const { t } = useTranslation();
  const { bienID } = useParams();

    useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [bienID]);

  const navigate = useNavigate();
  const auth = getAuth();

  const [vacation, setVacation] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const [selectedImage, setSelectedImage] =
    useState(0);

  // A stay searched on the Vacation page (?checkIn&checkOut, future and ordered) pre-fills the dates.
  const [startDate, setStartDate] =
    useState(() => searchedStay()?.start ?? null);

  const [endDate, setEndDate] =
    useState(() => searchedStay()?.end ?? null);

  const [reservedDates, setReservedDates] =
    useState([]);

  const [travelers, setTravelers] =
    useState(1);

  const [name, setName] =
    useState("");

  const [email, setEmail] =
    useState("");

  const [phone, setPhone] =
    useState("");

  const [message, setMessage] =
    useState(getDefaultMessage());

  const [emailError, setEmailError] =
    useState("");

  const [isSending, setIsSending] =
    useState(false);

  useEffect(() => {
    let mounted = true;

    const loadVacation = async () => {
      setLoading(true);
      setError("");

      try {
        const response =
          await getVacationById(bienID);

        if (mounted) {
          setVacation(response);
        }
      } catch (requestError) {
        if ([404, 410].includes(requestError?.status)) {
          // Unknown or deleted holiday rental: the « introuvable » page (404 for crawlers).
          if (mounted) setVacation(null);
          return;
        }
        if (mounted) {
          setError(
            requestError?.message ||
              t(
                "details_vacation.load_error",
                "Impossible de charger cette location."
              )
          );
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadVacation();

    return () => {
      mounted = false;
    };
  }, [bienID, t]);

  useEffect(() => {
    const loadReservedDates = async () => {
      try {
        const response =
          await getReservedDates(bienID);

        setReservedDates(
          Array.isArray(response)
            ? response
            : []
        );
      } catch (requestError) {
        console.error(
          "Erreur dates réservées :",
          requestError
        );

        setReservedDates([]);
      }
    };

    loadReservedDates();
  }, [bienID]);

  useEffect(() => {
    const user = auth.currentUser;

    if (!user) {
      return;
    }

    setName(
      user.displayName || ""
    );

    setEmail(
      user.email || ""
    );
  }, [auth]);

  const images = useMemo(() => {
    if (!vacation?.urlImages) {
      return [];
    }

    const rawImages = Array.isArray(
      vacation.urlImages
    )
      ? vacation.urlImages
      : String(
          vacation.urlImages
        ).split(",");

    return rawImages
      .map((image) =>
        String(image).trim()
      )
      .filter(Boolean);
  }, [vacation?.urlImages]);

  const getImageUrl = (image) => photoUrl(image, vacation?.folder);

  const normalPrice =
    Number(vacation?.prix) || 0;

  const reducedPrice =
    Number(vacation?.prixReduit) || 0;

  const hasOffer =
    Boolean(vacation?.offre) &&
    reducedPrice > 0 &&
    reducedPrice < normalPrice;

  const nightlyPrice = hasOffer
    ? reducedPrice
    : normalPrice;

  const discountPercentage =
    hasOffer && normalPrice > 0
      ? Math.round(
          ((normalPrice -
            reducedPrice) /
            normalPrice) *
            100
        )
      : 0;

  const totalDays = startDate && endDate ? Math.max(0, stayNights(startDate, endDate)) : 0;
  const priceCalculation = reservationEstimate(vacation, totalDays);

  const excludedDateIntervals =
    useMemo(() => {
      return reservedDates
        .map((item) => {
          const start = new Date(
            item?.startDate ??
              item?.Arrival ??
              item?.arrival
          );

          const end = new Date(
            item?.endDate ??
              item?.Depart ??
              item?.depart
          );

          if (
            Number.isNaN(
              start.getTime()
            ) ||
            Number.isNaN(
              end.getTime()
            )
          ) {
            return null;
          }

          return {
            start,
            end,
          };
        })
        .filter(Boolean);
    }, [reservedDates]);

  const activeAmenities =
    useMemo(() => {
      if (!vacation) {
        return [];
      }

      return amenitiesList.filter(
        (amenity) =>
          Boolean(
            vacation[
              amenity.key
            ]
          )
      );
    }, [vacation]);

  const formatPrice = (value) =>
    new Intl.NumberFormat(
      uiI18n.language,
      {
        maximumFractionDigits: 2,
      }
    ).format(Number(value) || 0);

  const validateEmail = (
    value
  ) =>
    /\S+@\S+\.\S+/.test(value);

  const handleEmailChange = (
    event
  ) => {
    const value =
      event.target.value;

    setEmail(value);

    setEmailError(
      value &&
        !validateEmail(value)
        ? t(
            "details_vacation.invalid_email",
            "Veuillez saisir une adresse e-mail valide."
          )
        : ""
    );
  };

  const handleSubmit = async (
    event
  ) => {
    event.preventDefault();

    if (isSending) {
      return;
    }

    const user =
      auth.currentUser;

    if (!user) {
      toast.error(
        t(
          "details_vacation.login_required",
          "Veuillez vous connecter pour effectuer une réservation."
        )
      );

      navigate("/SignIn");
      return;
    }

    if (
      !startDate ||
      !endDate ||
      totalDays <= 0
    ) {
      toast.error(
        t(
          "details_vacation.invalid_dates",
          "Sélectionnez des dates valides."
        )
      );

      return;
    }

    setIsSending(true);

    try {
      const payload = {
        name:
          name.trim(),

        email:
          email.trim(),

        phone:
          phone.trim(),

        message:
          message.trim(),

        Arrival:
          calendarDate(startDate),

        Depart:
          calendarDate(endDate),

        NbTraveler:
          Number(travelers),

        TotalDays:
          totalDays,

        Price:
          nightlyPrice,

        Total:
          priceCalculation.total,

        Discount:
          priceCalculation.discountAmount,

        Libelle:
          vacation?.libelle,

        Ads:
          window.location.href,

        uidLandlord:
          vacation?.uid,

        uidUser:
          user.uid,

        ContactName:
          user.displayName ||
          name,

        Email:
          user.email ||
          email,

        ProporietsID:
          bienID,
      };

      const result = await addReservation(payload);

      toast.success(
        (result?.total != null ? uiI18n.t("ui.confirmed_total", { total: result.total }) : "") + t(
          "details_vacation.reservation_sent",
          "Votre demande de réservation a été envoyée."
        )
      );

      setStartDate(null);
      setEndDate(null);
      setTravelers(1);
      setMessage(
        getDefaultMessage()
      );
    } catch (requestError) {
      console.error(
        "Erreur réservation :",
        requestError
      );

      toast.error(
        requestError?.message ||
          t(
            "details_vacation.network_error",
            "Une erreur réseau est survenue."
          )
      );
    } finally {
      setIsSending(false);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center bg-slate-50">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <main className="min-h-[60vh] bg-slate-50 px-4 py-16">
        <div className="mx-auto max-w-xl rounded-3xl border border-red-200 bg-red-50 p-8 text-center">
          <h1 className="text-xl font-black text-red-800">
            {t(
              "details_vacation.load_error_title",
              "Impossible de charger cette location"
            )}
          </h1>

          <p className="mt-3 text-sm text-red-600">
            {error}
          </p>
        </div>
      </main>
    );
  }

  if (!vacation) {
    return (
      <main className="flex min-h-[60vh] items-center justify-center bg-slate-50">
        <PageMeta titleKey="seo.notFound" />
        <p className="text-slate-500">
          {t(
            "listing.noData",
            "Cette location est introuvable."
          )}
        </p>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-slate-50">
      <PageMeta titleKey="seo.vacationListing" title={vacation.libelle} />
      <div className="mx-auto flex max-w-7xl flex-wrap items-start gap-2 px-4 py-3 sm:px-6 lg:px-8">
        <PrintButton type="vacation" id={vacation.id} />
        <EngagementActions kind="vacation" listing={vacation}/>
      </div>
      {/* GALERIE */}

      <section className="border-b border-slate-100 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="grid gap-3 md:grid-cols-[2fr_1fr]">
            <button
              type="button"
              onClick={() =>
                setSelectedImage(0)
              }
              className="relative h-[320px] overflow-hidden rounded-3xl bg-slate-200 sm:h-[440px]"
            >
              <img
                src={getImageUrl(
                  images[
                    selectedImage
                  ]
                )}
                alt={
                  vacation.libelle ||
                  uiI18n.t("ui.holiday_rental")
                }
                onError={(event) => {
                  event.currentTarget.onerror =
                    null;

                  event.currentTarget.src =
                    FALLBACK_IMAGE;
                }}
                className="h-full w-full object-cover"
              />

              {images.length > 0 && (
                <span className="absolute bottom-4 end-4 inline-flex items-center gap-2 rounded-full bg-slate-950/70 px-4 py-2 text-sm font-bold text-white backdrop-blur">
                  <LuImage size={17} />

                  {selectedImage + 1} /{" "}
                  {images.length}
                </span>
              )}
            </button>

            <div className="grid grid-cols-2 gap-3">
              {images
                .slice(0, 4)
                .map(
                  (
                    image,
                    index
                  ) => (
                    <button
                      type="button"
                      key={`${image}-${index}`}
                      onClick={() =>
                        setSelectedImage(
                          index
                        )
                      }
                      className={`
                        overflow-hidden
                        rounded-2xl
                        border-2
                        transition
                        ${
                          selectedImage ===
                          index
                            ? "border-green-500"
                            : "border-transparent"
                        }
                      `}
                    >
                      <img
                        src={getImageUrl(
                          image
                        )}
                        alt={`${vacation.libelle} - ${
                          index + 1
                        }`}
                        className="h-full w-full object-cover"
                      />
                    </button>
                  )
                )}
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="lina-detail-layout grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,380px)]">
          {/* CONTENU */}

          <div className="space-y-6">
            <article className="rounded-3xl border border-slate-100 bg-white p-6 shadow-sm">
              <div className="flex flex-col gap-5 sm:flex-row sm:justify-between">
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.16em] text-green-600">
                    {t(
                      "vacances",
                      "Location vacances"
                    )}
                  </p>

                  <h1 className="mt-2 text-3xl font-black text-slate-950">
                    {vacation.libelle}
                  </h1>

                  <p className="mt-3 flex items-center gap-2 text-sm text-slate-500">
                    <LuMapPin
                      size={17}
                      className="text-green-600"
                    />

                    {[
                      t(`delegations.${vacation.ville}.${vacation.delegation}`, vacation.delegation || ''),
                      t(`cities.${vacation.ville}`, vacation.ville || ''),
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </div>

                <div className="sm:text-end">
                  {hasOffer && (
                    <div className="flex items-center gap-2 sm:justify-end">
                      <span className="text-sm font-semibold text-slate-400 line-through">
                        {formatPrice(
                          normalPrice
                        )}{" "}
                        TND
                      </span>

                      <span className="rounded-full bg-red-50 px-2 py-1 text-xs font-black text-red-600">
                        -
                        {
                          discountPercentage
                        }
                        %
                      </span>
                    </div>
                  )}

                  {nightlyPrice > 0 ? (<p className="mt-1 text-3xl font-black text-green-600">
                    {formatPrice(
                      nightlyPrice
                    )}

                    <span className="ms-1 text-sm font-bold text-slate-500"> {uiI18n.t("ui.tnd_395")}{" "}
                      {t(
                        "details_vacation.per_night",
                        "nuit"
                      )}
                    </span>
                  </p>) : (<p className="text-sm font-semibold text-slate-600">{t("vacationPublication.noPrice")}</p>)}
                </div>
              </div>

              <div className="mt-6 grid grid-cols-2 gap-3 border-t border-slate-100 pt-6 sm:grid-cols-4">
                <Feature
                  icon={LuUsers}
                  label={`${vacation.maxGuests || 0} ${t(
                    "travelers",
                    "voyageurs"
                  )}`}
                />

                <Feature
                  icon={LuBedDouble}
                  label={`${vacation.chambres || 0} ${t(
                    "bedrooms",
                    "chambres"
                  )}`}
                />

                <Feature
                  icon={LuBedDouble}
                  label={`${vacation.lits || 0} ${t(
                    "beds",
                    "lits"
                  )}`}
                />

                <Feature
                  icon={LuBath}
                  label={`${vacation.sallesBains || vacation.SallesBains || 0} ${t(
                    "bathrooms",
                    "SDB"
                  )}`}
                />
              </div>
            </article>

            {vacation.description && (
              <article className="rounded-3xl border border-slate-100 bg-white p-6 shadow-sm">
                <h2 className="text-xl font-black text-slate-900">
                  {t(
                    "description",
                    "Description"
                  )}
                </h2>

                <p className="mt-4 whitespace-pre-line text-sm leading-7 text-slate-600">
                  {
                    vacation.description
                  }
                </p>
              </article>
            )}

            <article className="rounded-3xl border border-slate-100 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-black text-slate-900">
                {t(
                  "details_vacation.amenities",
                  "Équipements"
                )}
              </h2>

              {activeAmenities.length >
              0 ? (
                <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
                  {activeAmenities.map(
                    (amenity) => {
                      const Icon =
                        amenity.icon;

                      return (
                        <div
                          key={
                            amenity.key
                          }
                          className="flex items-center gap-3 rounded-2xl bg-slate-50 p-4"
                        >
                          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-green-600 shadow-sm">
                            <Icon
                              size={
                                18
                              }
                            />
                          </span>

                          <span className="text-sm font-bold text-slate-700">
                            {t(
                              amenity.labelKey,
                              amenity.fallback
                            )}
                          </span>
                        </div>
                      );
                    }
                  )}
                </div>
              ) : (
                <p className="mt-4 text-sm text-slate-500">
                  {t(
                    "details_vacation.no_amenities",
                    "Aucun équipement renseigné."
                  )}
                </p>
              )}
            </article>
          </div>

          {/* RÉSERVATION */}

          <aside className="lg:sticky lg:top-[98px]">
            <PublisherCard listing={vacation} vacation />
            <form
              onSubmit={
                handleSubmit
              }
              className="rounded-3xl border border-slate-100 bg-white p-5 shadow-xl shadow-slate-900/5 sm:p-6"
            >
              <div className="flex items-end justify-between gap-3">
                <div>
                  {nightlyPrice > 0 ? (<p className="text-2xl font-black text-green-600">
                    {formatPrice(
                      nightlyPrice
                    )}{" "}
                    TND
                  </p>) : (<p className="text-sm font-semibold text-slate-600">{t("vacationPublication.noPrice")}</p>)}

                  {nightlyPrice > 0 && (<p className="text-xs font-medium text-slate-500">
                    {t(
                      "details_vacation.per_night",
                      "par nuit"
                    )}
                  </p>)}
                </div>

                {hasOffer && (
                  <span className="rounded-full bg-red-50 px-3 py-1 text-xs font-black text-red-600">
                    -
                    {
                      discountPercentage
                    }
                    %
                  </span>
                )}
              </div>

              <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
                <FormField
                  label={t(
                    "details_vacation.arrival_date",
                    "Arrivée"
                  )}
                >
                  <DatePicker
                    locale={uiI18n.language.startsWith("ar") ? arTN : uiI18n.language.startsWith("en") ? enGB : fr}
                    previousMonthButtonLabel={uiI18n.t("ui.previous_month")}
                    nextMonthButtonLabel={uiI18n.t("ui.next_month")}
                    selected={
                      startDate
                    }
                    onChange={(
                      date
                    ) => {
                      setStartDate(
                        date
                      );

                      if (
                        endDate &&
                        date &&
                        endDate <=
                          date
                      ) {
                        setEndDate(
                          null
                        );
                      }
                    }}
                    excludeDateIntervals={
                      excludedDateIntervals
                    }
                    minDate={
                      new Date()
                    }
                    placeholderText={t(
                      "details_vacation.selectDay",
                      "Sélectionner"
                    )}
                    dateFormat="dd/MM/yyyy"
                    className={
                      inputClassName
                    }
                  />
                </FormField>

                <FormField
                  label={t(
                    "details_vacation.departure_date",
                    "Départ"
                  )}
                >
                  <DatePicker
                    locale={uiI18n.language.startsWith("ar") ? arTN : uiI18n.language.startsWith("en") ? enGB : fr}
                    previousMonthButtonLabel={uiI18n.t("ui.previous_month")}
                    nextMonthButtonLabel={uiI18n.t("ui.next_month")}
                    selected={
                      endDate
                    }
                    onChange={
                      setEndDate
                    }
                    excludeDateIntervals={
                      excludedDateIntervals
                    }
                    minDate={
                      startDate
                        ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1)
                        : new Date()
                    }
                    placeholderText={t(
                      "details_vacation.selectDay",
                      "Sélectionner"
                    )}
                    dateFormat="dd/MM/yyyy"
                    className={
                      inputClassName
                    }
                  />
                </FormField>
              </div>

              <FormField
                label={t(
                  "travelers",
                  "Voyageurs"
                )}
              >
                <div className="relative">
                  <LuUsers
                    size={17}
                    className="pointer-events-none absolute start-4 top-1/2 -translate-y-1/2 text-slate-400"
                  />

                  <input
                    type="number"
                    min="1"
                    max={
                      Number(
                        vacation.maxGuests
                      ) || 20
                    }
                    value={
                      travelers
                    }
                    onChange={(
                      event
                    ) =>
                      setTravelers(
                        Math.max(
                          1,
                          Number(
                            event
                              .target
                              .value
                          ) ||
                            1
                        )
                      )
                    }
                    className={`${inputClassName} ps-11`}
                  />
                </div>
              </FormField>

              <FormField
                label={t(
                  "details_vacation.name",
                  "Nom"
                )}
              >
                <input
                  type="text"
                  value={name}
                  onChange={(
                    event
                  ) =>
                    setName(
                      event
                        .target
                        .value
                    )
                  }
                  required
                  className={
                    inputClassName
                  }
                />
              </FormField>

              <FormField
                label={t(
                  "details_vacation.email",
                  "E-mail"
                )}
              >
                <input
                  type="email"
                  value={email}
                  onChange={
                    handleEmailChange
                  }
                  required
                  className={
                    inputClassName
                  }
                />

                {emailError && (
                  <p className="mt-1 text-xs font-medium text-red-500">
                    {emailError}
                  </p>
                )}
              </FormField>

              <FormField
                label={t(
                  "details_vacation.phone",
                  "Téléphone"
                )}
              >
                <input
                  type="tel"
                  value={phone}
                  onChange={(
                    event
                  ) =>
                    setPhone(
                      event.target.value
                        .replace(
                          /[^0-9+\s]/g,
                          ""
                        )
                        .slice(
                          0,
                          20
                        )
                    )
                  }
                  required
                  className={
                    inputClassName
                  }
                />
              </FormField>

              <FormField
                label={t(
                  "details_vacation.message",
                  "Message"
                )}
              >
                <textarea
                  rows={4}
                  value={message}
                  onChange={(
                    event
                  ) =>
                    setMessage(
                      event
                        .target
                        .value
                    )
                  }
                  className={`${inputClassName} min-h-[110px] resize-y py-3`}
                />
              </FormField>

              {totalDays > 0 && nightlyPrice > 0 && (
                <div className="mt-5 rounded-2xl border border-green-100 bg-green-50 p-4">
                  <div className="flex items-center justify-between text-sm text-slate-600">
                    <span>
                      {formatPrice(
                        nightlyPrice
                      )}{" "} {uiI18n.t("ui.tnd")} ×{" "}
                      {totalDays}{" "}
                      {t(
                        "details_vacation.nights",
                        "nuits"
                      )}
                    </span>

                    <span className="font-bold">
                      {formatPrice(
                        priceCalculation.subtotal
                      )}{" "}
                      TND
                    </span>
                  </div>

                  {priceCalculation.discountAmount >
                    0 && (
                    <div className="mt-2 flex items-center justify-between text-sm text-green-700">
                      <span>
                        {t(
                          totalDays >= 30 ? "stay.monthlyDiscount" : "stay.weeklyDiscount",
                          "Réduction"
                        )}{" "}
                        (
                        {
                          priceCalculation.discountRate
                        }
                        %)
                      </span>

                      <span className="font-bold">
                        -
                        {formatPrice(
                          priceCalculation.discountAmount
                        )}{" "}
                        TND
                      </span>
                    </div>
                  )}

                  <div className="mt-4 flex items-center justify-between border-t border-green-200 pt-4">
                    <span className="font-black text-slate-900">
                      {t(
                        "stay.estimatedTotal",
                        "Total estimé"
                      )}
                    </span>

                    <span className="text-xl font-black text-green-700">
                      {formatPrice(
                        priceCalculation.total
                      )}{" "}
                      TND
                    </span>
                  </div>
                </div>
              )}

              {nightlyPrice <= 0 && <p role="status" className="mt-4 text-sm text-slate-600">{t("vacationPublication.contactForPrice")}</p>}
                <button
                type="submit"
                disabled={
                  nightlyPrice <= 0 || isSending ||
                  !startDate ||
                  !endDate ||
                  !name.trim() ||
                  !email.trim() ||
                  Boolean(
                    emailError
                  ) ||
                  !phone.trim()
                }
                className="
                  mt-6
                  inline-flex
                  h-12
                  w-full
                  items-center
                  justify-center
                  gap-2
                  rounded-2xl
                  bg-green-600
                  px-6
                  text-sm
                  font-black
                  text-white
                  shadow-lg
                  shadow-green-600/20
                  transition
                  hover:bg-green-700
                  disabled:cursor-not-allowed
                  disabled:bg-slate-300
                  disabled:shadow-none
                  focus:outline-none
                  focus:ring-4
                  focus:ring-green-500/20
                "
              >
                {isSending ? (
                  <>
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />

                    {t(
                      "details_vacation.sending",
                      "Envoi..."
                    )}
                  </>
                ) : (
                  <>
                    <LuSend
                      size={
                        17
                      }
                    />

                    {t(
                      "details_vacation.send_reservation",
                      "Envoyer la demande"
                    )}
                  </>
                )}
              </button>
            </form>
          </aside>
        </div>
      </section>
    </main>
  );
};

function FormField({
  label,
  children,
}) {
  useUiTranslation();
  return (
    <label className="mt-4 block">
      <span className="mb-2 block text-sm font-black text-slate-700">
        {label}
      </span>

      {children}
    </label>
  );
}

function Feature({
  icon: Icon,
  label,
}) {
  useUiTranslation();
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-slate-50 p-3">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-green-600 shadow-sm">
        <Icon size={18} />
      </span>

      <span className="text-sm font-bold text-slate-700">
        {label}
      </span>
    </div>
  );
}

export default DetailsVacation;
